import { lazy } from "react";
import { Navigate, Outlet, RouteObject } from "react-router-dom";
import BackgroundLayoutWithLogo from "ui/common/components/layout/BackgroundLayoutWithLogo/BackgroundLayoutWithLogo";
import LoggedOutRoute from "../containers/LoggedOutRoute/LoggedOutRoute";
import RecoverPasswordPage from "../pages/RecoverPasswordPage/RecoverPasswordPage";
import UserDetailsInRoute from "../containers/UserDetailsInRoute/UserDetailsInRoute";
import { AuthRoutes } from "./AuthRouter.types";
import BaseLayout from "ui/common/components/layout/BaseLayout/BaseLayout";
import SuccessfulRegistrationPage from "../pages/SuccessfulRegistrationPage/SuccessfulRegistrationPage";

const RegisterPage = lazy(() => import("../pages/RegisterPage/RegisterPage"));
const LoginPage = lazy(() => import("../pages/LoginPage/LoginPage"));
const VerifyEmailPage = lazy(() => import("../pages/VerifyEmailPage/VerifyEmailPage"));

export const useAuthRoutes = (): RouteObject[] => {
    return [
        {
            path: AuthRoutes.MAIN,
            element: (
                <LoggedOutRoute>
                    <BackgroundLayoutWithLogo>
                        <Outlet />
                    </BackgroundLayoutWithLogo>
                </LoggedOutRoute>
            ),
            children: [
                {
                    path: AuthRoutes.MAIN,
                    element: <Navigate to={AuthRoutes.LOGIN} />,
                },
                {
                    path: AuthRoutes.LOGIN,
                    element: <LoginPage />,
                },
                {
                    path: AuthRoutes.REGISTER,
                    element: <RegisterPage />,
                },
                { path: AuthRoutes.RECOVER_PASSWORD, element: <RecoverPasswordPage /> },
                {
                    path: AuthRoutes.VERIFY_EMAIL,
                    element: (
                        <UserDetailsInRoute>
                            <VerifyEmailPage />
                        </UserDetailsInRoute>
                    ),
                },
            ],
        },
        {
            path: AuthRoutes.MAIN,
            element: (
                <LoggedOutRoute>
                    <BaseLayout>
                        <Outlet />
                    </BaseLayout>
                </LoggedOutRoute>
            ),
            children: [
                {
                    path: AuthRoutes.SUCCESSFUL_REGISTER,
                    element: <SuccessfulRegistrationPage />,
                },
            ],
        },
    ];
};
